export default function DesertDinoIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#9FDCFF" />
      <circle cx="50" cy="14" r="7" fill="#FFE38A" />
      <rect x="0" y="48" width="64" height="16" fill="#F2D7A0" />
      <path d="M0 48h64" stroke="#8A6A3A" strokeWidth="2" />
      <rect x="46" y="28" width="6" height="21" rx="3" fill="#3FA65A" />
      <rect x="41" y="31" width="4" height="9" rx="2" fill="#3FA65A" />
      <rect x="41" y="38" width="7" height="3" fill="#3FA65A" />
      <rect x="53" y="34" width="4" height="8" rx="2" fill="#3FA65A" />
      <rect x="50" y="40" width="6" height="3" fill="#3FA65A" />
      <path d="M4 34l8-6v11z" fill="#5DBB63" />
      <rect x="9" y="26" width="20" height="18" rx="8" fill="#5DBB63" />
      <rect x="19" y="16" width="19" height="14" rx="6" fill="#5DBB63" />
      <rect x="17" y="31" width="9" height="11" rx="4" fill="#BFEAA8" />
      <circle cx="31" cy="21" r="3" fill="#fff" />
      <circle cx="32" cy="21" r="1.6" fill="#1d1d2b" />
      <rect x="13" y="42" width="5" height="7" rx="2" fill="#3E8E47" />
      <rect x="21" y="42" width="5" height="5" rx="2" fill="#3E8E47" />
    </svg>
  );
}
